import { UserAgent } from '@quentin-sommer/react-useragent';
import React from 'react';
import ContentLoader from 'react-content-loader';
import styles from './filter-loader.module.scss';

const FilterLoader: React.FC = props => {
  const FilterLoaderDesktop = (
    <div className={styles.loaderDesktop}>
      <ContentLoader
        uniqueKey="checkin-loading"
        viewBox="0 0 1128 800"
        height={800}
        width={1128}
        speed={2}
        {...props}
      >
        <rect x="0" y="26" rx="14" ry="14" width="134" height="20" />
        <rect x="0" y="66" rx="14" ry="14" width="200" height="124" />
        <rect x="212" y="80" rx="14" ry="14" width="218" height="20" />
        <rect x="212" y="118" rx="14" ry="14" width="413" height="16" />
        <rect x="212" y="150" rx="14" ry="14" width="113" height="16" />

        <rect x="0" y="211" rx="14" ry="14" width="465" height="16" />
        <rect x="0" y="243" rx="14" ry="14" width="330" height="16" />
        <rect x="0" y="275" rx="14" ry="14" width="573" height="16" />
        <rect x="0" y="307" rx="14" ry="14" width="433" height="16" />

        <rect x="0" y="400" rx="14" ry="14" width="465" height="16" />
        <rect x="0" y="440" rx="14" ry="14" width="330" height="16" />
        <rect x="0" y="480" rx="14" ry="14" width="573" height="16" />
        <rect x="0" y="520" rx="14" ry="14" width="433" height="16" />

        <rect x="768" y="0" rx="14" ry="14" width="218" height="20" />
        <rect x="768" y="44" rx="14" ry="14" width="355" height="16" />
        <rect x="768" y="76" rx="14" ry="14" width="113" height="16" />
        <rect x="768" y="108" rx="14" ry="14" width="219" height="16" />

        <rect x="768" y="181" rx="14" ry="14" width="218" height="20" />
        <rect x="768" y="226" rx="14" ry="14" width="355" height="16" />
        <rect x="768" y="258" rx="14" ry="14" width="113" height="16" />
        <rect x="768" y="290" rx="14" ry="14" width="219" height="16" />
      </ContentLoader>
    </div>
  );

  const FilterLoaderMobile = (
    <div className={styles.loaderMobile}>
      <ContentLoader
        uniqueKey="checkin-loading"
        viewBox="0 0 350 500"
        height={500}
        width={350}
        speed={2}
        {...props}
      >
        <rect x="0" y="16" rx="14" ry="14" width="300" height="18" />
        <rect x="0" y="60" rx="14" ry="14" width="140" height="16" />
        <rect x="0" y="100" rx="14" ry="14" width="260" height="30" />
        <rect x="0" y="150" rx="14" ry="14" width="140" height="16" />
        <rect x="0" y="190" rx="14" ry="14" width="260" height="30" />
        <rect x="0" y="240" rx="14" ry="14" width="100" height="16" />
        <rect x="0" y="270" rx="14" ry="14" width="180" height="30" />
        <rect x="0" y="310" rx="14" ry="14" width="220" height="30" />
      </ContentLoader>
    </div>
  );

  return (
    <>
      <UserAgent computer>{FilterLoaderDesktop}</UserAgent>
      <UserAgent mobile>{FilterLoaderMobile}</UserAgent>
    </>
  );
};

export default FilterLoader;
